import styled from "styled-components";
import { Theme } from "../../Theme";

const StyledText = styled.span`
    font-size: ${(props) => props.fontSize || Theme.text.default.fontSize};
    font-family: ${(props) => props.fontFamily || Theme.text.default.fontFamily};
    letter-spacing: ${(props) => props.letterSpacing || Theme.text.default.letterSpacing};
    line-height: ${(props) => props.lineHeight || Theme.text.default.lineHeight};
    font-weight: ${(props) => props.fontWeight || Theme.text.default.fontWeight};
    color: ${(props) => props.fontColor || Theme.text.default.fontColor};
    text-align: ${(props) => props.textAlign || "left"};
    vertical-align: ${(props) => props.verticalAlign || "center"};
    flex: ${(props) => props.flex || "none"};
    min-width: 0;
    width: ${(props) => props.width};
    cursor: ${(props) => props.cursor || "inherit"};

    ${(props) =>
        props.useEllipsis
            ? `
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;`
            : `overflow-wrap: ${props.overFlowWrap || "break-word"};`}
`;

/**
 * 텍스트 컴포넌트를 반환합니다.
 * @param {string} children - 텍스트
 * @param {string} fontSize - 폰트 사이즈
 * @param {string} fontFamily - 폰트명
 * @param {string} letterSpacing - 글자간 간격
 * @param {string} lineHeight - 글자 높이
 * @param {string} fontWeight - 글자 굵기
 * @param {string} fontColor - 글자색
 * @param {string} textAlign - 텍스트 정렬
 */
function CustomText({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    useEllipsis,
    ...rest
}) {
    return (
        <StyledText
            fontSize={fontSize}
            fontFamily={fontFamily}
            letterSpacing={letterSpacing}
            lineHeight={lineHeight}
            fontWeight={fontWeight}
            fontColor={fontColor}
            textAlign={textAlign}
            useEllipsis={useEllipsis}
            {...rest}
        >
            {children}
        </StyledText>
    );
}

export function T1Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.t1?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.t1?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export function T2Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.t2?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.t2?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export function T3Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.t3?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.t3?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export function C1Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.c1?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.c1?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export function C2Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.c2?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.c2?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export function C3Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.c3?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.c3?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export function C4Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.c4?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.c4?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export function C5Text({
    children,
    fontSize,
    fontFamily,
    letterSpacing,
    lineHeight,
    fontWeight,
    fontColor,
    textAlign,
    ...rest
}) {
    return (
        <CustomText
            fontSize={fontSize || Theme.text.c5?.fontSize}
            fontFamily={fontFamily || Theme.text.default?.fontFamily}
            letterSpacing={letterSpacing || Theme.text.default?.letterSpacing}
            lineHeight={lineHeight || Theme.text.default?.lineHeight}
            fontWeight={fontWeight || Theme.text.c5?.fontWeight}
            fontColor={fontColor || Theme.text.default?.color}
            textAlign={textAlign}
            {...rest}
        >
            {children}
        </CustomText>
    );
}

export default CustomText;
